import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Table, Form, Input , Button, Popconfirm, message, Select, Row, Col } from 'antd';
import { DatePicker, CrmSelectBox, CompanySelectBox } from 'components/atoms'
import {  useBillPublicB2CDetail, useRefCode } from 'hooks';
import { TableWrapper, FileViewerModal } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import moment, { Moment } from 'moment';
import { dateFormat } from 'utils/date-utils';
import {  DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { endpoints } from 'services';
import { usePopupManager } from 'react-popup-manager';
import CheckInputModal from 'components/molecules/CheckInputModal';
import useStore from 'store';

export interface BillPublicModalProps extends PopupProps {
    id: number;
}

const BillPublicModal = ({ isOpen, onClose, id }: BillPublicModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [companySrl, setCompanySrl] = useState<number>(0);
  const [dropMemo, setDropMemo] = useState<string>('');  
  const [isCheckInput, setIsCheckInput] = useState<boolean>(false);

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const { TextArea } = Input;
   const auth = useStore((state) => state.auth);  

   const columns: ColumnsType<BillItemB2CInfoDto> = [
    {
      title: '교육생',
      dataIndex: 'name_kor',
      key: 'name_kor',
      width: '120px',
      align: 'center',
      ellipsis: true,
    },
    {
     title: '부서',
     dataIndex: 'department',
     key: 'department',
     width: 'auto',
     align: 'center',
     ellipsis: true,
   },   
   {
     title: '직책',
     dataIndex: 'position',
     key: 'position',
     width: 'auto',
     align: 'center',
     ellipsis: true,
   },   
   {
     title: '교육비',
     dataIndex: 'mem_price',
     key: 'mem_price',
     width: '100px',
     align: 'right',
     ellipsis: true,
     render: (mem_price, record) => {
      return (
        mem_price && mem_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }     
   }, 
   {
    title: '미발행매출',
    dataIndex: 'no_bill_price',
    key: 'no_bill_price',
    width: '100px',
    align: 'right',
    ellipsis: true,
    render: (no_bill_price, record) => {
      return (
        no_bill_price && no_bill_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }      
  },  
  {
    title: '발행금액',
    dataIndex: 'bill_pirce',
    key: 'bill_pirce',
    width: '100px',
    align: 'right',
    ellipsis: true,
    render: (bill_pirce, record) => {
      return (
        bill_pirce && bill_pirce.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }     
  },      
  ];
   /* ======================================================
   * events
   * ====================================================== */
   
  const onCloseCancle = () => {
    onClose?.(false); 
  }  

  const onDropMemoClose = (isOk, memo?) => {
    if (isOk) {
      const data = {
        id: id,
        status_type:'drop',
        title: form.getFieldValue("title"),
        memo: form.getFieldValue("memo"),
        drop_memo: memo,
        acc_name: form.getFieldValue("acc_name"),
        acc_phone: form.getFieldValue("acc_phone"),
        acc_email: form.getFieldValue("acc_email"),
        company_srl: form.getFieldValue("company_srl"),
        bill_type: form.getFieldValue("bill_type"),
        bill_day: form.getFieldValue("bill_day") ? dateFormat(form.getFieldValue("bill_day"), 'YYYY-MM-DD'):'null',
      }
      billStatusUpdate(data)    
    } 
    setIsCheckInput(false);
  }

  const onUpdateState = (status: string) => {
    if (status === 'drop') {
      setDropMemo('');
      setIsCheckInput(true);
    } else {
      const data = {
        id: id,
        status_type:status,
        title: form.getFieldValue("title"),
        memo: form.getFieldValue("memo"),        
        company_srl: form.getFieldValue("company_srl"),
        acc_name: form.getFieldValue("acc_name"),
        acc_phone: form.getFieldValue("acc_phone"),
        acc_email: form.getFieldValue("acc_email"),
        bill_type: form.getFieldValue("bill_type"),
        bill_day: form.getFieldValue("bill_day") ? dateFormat(form.getFieldValue("bill_day"), 'YYYY-MM-DD'):'null',
      }
      billStatusUpdate(data) 
    }
  }

  const onUpdate = () => {
    const data = {
      id: id,
      title: form.getFieldValue("title"),
      memo: form.getFieldValue("memo"),
      company_srl: form.getFieldValue("company_srl"),
      acc_name: form.getFieldValue("acc_name"),
      acc_phone: form.getFieldValue("acc_phone"),
      acc_email: form.getFieldValue("acc_email"),
      bill_type: form.getFieldValue("bill_type"),
      bill_day: form.getFieldValue("bill_day") ? dateFormat(form.getFieldValue("bill_day"), 'YYYY-MM-DD'):'null',
    }
    billUpdate(data) 
  }


  const onDownload = (fileSeq:number, fileName: string): void => {
    axios({
      url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
      method: 'get',
      responseType: 'blob',
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
      });
    };

    const onOpenFileViewer = (fileId: number, fileName: string) => {
      open(FileViewerModal, {
        fileid: fileId,
        filename: fileName,
        seq: 0,
        gubun:'',
        editable: false,
        onClose: (isOk) => {
          if (isOk) {};
        },
      });   
     }   
  /* ======================================================
   * hooks
   * ====================================================== */
  const { billInfo, billItems, updateSuccess, billUpdate, updateStatusSuccess, billStatusUpdate } = useBillPublicB2CDetail(id); 
  const { refCodeList: billType } = useRefCode({field:'bill_type', status_type: 'AV'});   
  const { open } = usePopupManager();  
  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (!!billInfo) {
      form.setFieldsValue({
          bill_type: billInfo.bill_type,
          bill_day: (!!billInfo.bill_day && billInfo.bill_day !== '0000-00-00') ? moment(billInfo.bill_day, "YYYY-MM-DD") : undefined,
          acc_name: billInfo.acc_name,
          acc_phone: billInfo.acc_phone,
          acc_email: billInfo.acc_email,
          company_srl: billInfo.company_srl, 
          memo: billInfo.memo, 
          title: billInfo.title,
      });
      setCompanySrl(billInfo.company_srl); 
    }     
  }, [billInfo])

  useEffect(() => {
    if (updateSuccess || updateStatusSuccess)
    onClose?.(true);     
  }, [updateSuccess, updateStatusSuccess])  

    return (
      <>
        <ModalWrapper open={isOpen} onCancel={onCloseCancle} width={850} title={billInfo?.status_type === 'drop'?'반려된 요청서':'계산서 발행 내역서'} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
            <Form
                    form={form}
                    name="RefCode"
                    layout="horizontal"  
                    labelCol={{ flex: '100px' }}
                    style={{width:'100%', marginBottom:'20px'}}
                >
                    <Form.Item label={'고객사'}>
                      {(!!companySrl)? (
                      <CompanySelectBox required={false} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); }} view_info/>
                      ): (
                        <>
                          <label>{billInfo?.company_name}</label>
                          {(billItems && billItems.length > 0 && billItems[0].business_file_id > 0) && (
                            <>
                              <Button onClick={()=>{onDownload(billItems[0].business_file_id, billItems[0].business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                              {isFileViewer(billItems[0].business_file_name) && (<Button onClick={()=>{onOpenFileViewer(billItems[0].business_file_id, billItems[0].business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                            </>
                          )}
                        </>
                      )}

                    </Form.Item>   
                    <Form.Item label={'결제담당자'}>
                      {(billInfo?.public_company === 'Y')? (
                      <>
                        <label style={{ display: 'inline-block', padding: '5px' }}>이름 : </label>
                        <Form.Item name={'acc_name'}  style={{ width:'100px', display: 'inline-block', marginRight: '10px' }}>
                          <Input />  
                        </Form.Item>
                        <label style={{ display: 'inline-block', padding: '5px' }}>전화번호 : </label>
                        <Form.Item name={'acc_phone'}  style={{ width:'120px', display: 'inline-block', marginRight: '10px' }}>
                          <Input />  
                        </Form.Item>
                        <label style={{ display: 'inline-block', padding: '5px' }}>이메일 : </label>
                        <Form.Item name={'acc_email'}  style={{ width:'200px', display: 'inline-block', marginRight: '10px' }}>
                          <Input />  
                        </Form.Item>
                      </>
                      ): (billItems && billItems.length > 0)? (
                        <label>{billItems[0].acc_name}&nbsp;&nbsp;&nbsp;(전화번호 : {billItems[0].acc_phone}, 이메일 : {billItems[0].acc_email})</label>
                      ):(<></>)}
                      
                    </Form.Item>                                         
                    <Row>
                      <Col span={12}>
                        <Form.Item label={'프로젝트명'}>
                            <label>{billInfo?.group_name}</label>                  
                        </Form.Item>   
                      </Col>
                      <Col span={12}>
                        <Form.Item label={'기간'}>
                            <label>{billInfo?.group_date}</label>                  
                        </Form.Item>                           
                      </Col>
                    </Row>  
                    <Form.Item name="bill_type" label={'발행구분'}>
                        <Select placeholder="강의구분 선택" style={{width:"150px"}}>
                        {billType?.map((item) => {
                            return (<Select.Option key={item.name} value={item.name}>{item.value}</Select.Option>)
                        })}                        
                        </Select>  
                      </Form.Item>   
                    <Row>
                      <Col span={12}>
                      <Form.Item name="bill_day" label={'발행일'}>
                          <DatePicker showTime={false} format="YYYY-MM-DD" />      
                        </Form.Item>                              
                      </Col>
                      <Col span={12}>
                      <Form.Item label={'요청자'}>
                          <label>{billInfo?.who_create}</label>    
                        </Form.Item>    
                        </Col>
                    </Row>                         
                    <Form.Item name='memo' label={'메모'}>
                        <TextArea rows={2} placeholder='일정 메모를 입력하세요'/>   
                    </Form.Item>    
                    {(billInfo?.status_type === 'drop') && (
                    <Form.Item label={'반려사유'}>
                        <label>{billInfo?.drop_memo}</label>
                    </Form.Item>                         
                    )}                                                                               
                </Form> 
                <TableWrapper isSearch={false}>
                    <Table
                        tableLayout="fixed"
                        dataSource={billItems}
                        pagination={false}
                        columns={columns}
                        style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                        showSorterTooltip={false}
                        scroll={{ y: 240 }}
                    />
                </TableWrapper>                

                <div style={{float:"right"}}>
                  <label>발행금액: {billInfo?.bill_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원 (vat 포함: {billInfo&&(billInfo.bill_price*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>
                </div>
                {billInfo?.status_type !== 'drop' && (
                <ButtonGroup className={'buttonsWrapper'}>
                <Button onClick={()=>{onClose?.(false)}}>닫기</Button>
                <Space>
                  {(billInfo?.status_type === 'confirm')? (
                    (auth.login?.div?.split(',').some(item => ['102', '999'].includes(item))) && (
                      <Popconfirm
                          title="결재가 승인된 항목입니다. 반려 하시겠습니까?"
                          okText="반려"
                          cancelText="취소"
                          onConfirm={() => { onUpdateState('drop')}}
                      >   
                          <Button danger>반려</Button>
                      </Popconfirm>
                    )
                  ): (billInfo?.status_type === 're-request') ? (
                    <>
                      <Button onClick={onUpdate}>저장</Button>
                      <Popconfirm
                          title="결재를 다시 발행 하시겠습니까?"
                          okText="재발행"
                          cancelText="취소"
                          onConfirm={() => { onUpdateState('request') }}
                      >   
                          <Button type="primary">재발행</Button>
                      </Popconfirm>                     
                    </>
                  ) : (
                    (auth.login?.div?.split(',').some(item => ['102', '999'].includes(item))) && (
                      <>
                        <Popconfirm
                            title="결재 요청을 재요청 하시겠습니까?"
                            okText="재요청"
                            cancelText="취소"
                            onConfirm={() => {onUpdateState('re-request')}}
                        >   
                            <Button>재요청</Button>
                        </Popconfirm> 
                        <Button onClick={onUpdate}>저장</Button>
                        <Popconfirm
                            title="결재 요청을 반려 하시겠습니까?"
                            okText="반려"
                            cancelText="취소"
                            onConfirm={() => {onUpdateState('drop')}}
                        >   
                            <Button danger>반려</Button>
                        </Popconfirm>                          
                        <Popconfirm
                            title="결재 요청을 승인 하시겠습니까?"
                            okText="승인"
                            cancelText="취소"
                            onConfirm={() => { onUpdateState('confirm') }}
                        >   
                            <Button type="primary">승인</Button>
                        </Popconfirm>                   
                      </>                      
                    )
                  )}
                </Space>
            </ButtonGroup>  
                )}
            </Space>     
        </ModalWrapper>  
        <CheckInputModal
          title="반려 사유 입력"
          memo={dropMemo}
          visible={isCheckInput}
          onOk={onDropMemoClose}
          onCancel={onDropMemoClose}
        /> 
      </>         
    )    
};

export default React.memo(BillPublicModal);    